import adminApiClient from "@/lib/api/admin-api-client";

export type PortalUserStatus = "pending" | "active" | "verified";

export type AdminPortalUser = {
  id: string;
  contact_name: string;
  email: string;
  company_name: string;
  status: PortalUserStatus;
  created_at: string;
  access_request_count: number;
};

export type AdminListPortalUsersResponse = {
  users: AdminPortalUser[];
  total: number;
};

export type AdminListPortalUsersParams = {
  q?: string;
  status?: PortalUserStatus;
  page?: number;
  limit?: number;
};

const ADMIN_PORTAL_USERS_PATH = "/api/v1/admin/portal-users";

export async function listAdminPortalUsers(
  params: AdminListPortalUsersParams = {},
): Promise<AdminListPortalUsersResponse> {
  const { data } = await adminApiClient.get<AdminListPortalUsersResponse>(
    ADMIN_PORTAL_USERS_PATH,
    {
      params: {
        ...(params.q?.trim() ? { q: params.q.trim() } : {}),
        ...(params.status ? { status: params.status } : {}),
        ...(params.page ? { page: params.page } : {}),
        ...(params.limit ? { limit: params.limit } : {}),
      },
    },
  );
  return data;
}

export function portalUserStatusLabel(status: PortalUserStatus): string {
  if (status === "verified") return "Verified";
  if (status === "active") return "Active";
  return "Pending";
}

export function formatPortalUserDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
